import { useMutation } from '@apollo/client'
import {
  BulkUpdateItemsDocument,
  BulkUpdateProcessesItemItemsInput,
  GetProcessDetailDocument,
} from 'generated/resources/graphql'

export type BulkUpdateItem = BulkUpdateProcessesItemItemsInput

export const useBulkUpdateItems = () => {
  const [executeMutation, { loading }] = useMutation(BulkUpdateItemsDocument)

  const bulkUpdateItems = async (items: BulkUpdateItem[], processId: string) => {
    const { data, errors } = await executeMutation({
      variables: {
        items,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessDetailDocument,
          variables: {
            id: processId,
          },
        },
      ],
    })

    if (errors?.length || data?.processesMutations?.bulkUpdateProcessesItem?.errors.length) {
      throw (
        'Could not update step: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.bulkUpdateProcessesItem?.errors || []),
        ])
      )
    }
  }

  return {
    bulkUpdateItems,
    loading,
  }
}
